<template>
  <div class="asc-duplicate-name">
    <asc-label :value="getTitle" size="md"></asc-label>
  </div>
</template>

<script>
import AscLabel from '@/components/atoms/AscLabel'

export default {
  name: 'AscDuplicateName',

  components: {
    AscLabel,
  },

  props: {
    name: {
      type: String,
      default: '() => []',
    },
  },

  computed: {
    getTitle() {
      return `The name "${this.name}" is already taken. Please choose a different name.`
    },
  },
}
</script>
